var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6066 1.6066C21.6304 0.630359 20.0474 0.630244 19.0711 1.60659L11.9999 8.67759L4.92885 1.60652C3.95261 0.630282 2.36966 0.630167 1.39331 1.60651C0.416947 2.58285 0.417048 4.16578 1.39329 5.14203L8.46436 12.2131L1.39323 19.2841C0.416869 20.2604 0.41697 21.8434 1.39321 22.8196C2.36945 23.7959 3.9524 23.796 4.92876 22.8196L11.9999 15.7486L19.071 22.8197C20.0472 23.7959 21.6301 23.7961 22.6065 22.8197C23.5829 21.8434 23.5828 20.2604 22.6065 19.2842L15.5355 12.2131L22.6066 5.14212C23.5829 4.16578 23.5828 2.58284 22.6066 1.6066Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelWhite);
export default __webpack_public_path__ + "static/media/delWhite.df33be4b203d7d6136c10f0f20de3b85.svg";
export { ForwardRef as ReactComponent };